import { useQuery } from 'react-query'

import { type OrderDraftPreferredCreationFlowEnum } from '@webapp/platform/iam/entities/enums/OrderDraftPreferredCreationFlowEnum'
import { userPreferenceQueryConfig } from '@webapp/platform/iam/query-configs/userPreferenceQueryConfig'

type UseQueryOrderRequestFlowPreferenceReturn = {
  preferredOrderRequestFlow: OrderDraftPreferredCreationFlowEnum | undefined
  isFetching: boolean
}

export const useQueryOrderRequestFlowPreference = (
  userId: number
): UseQueryOrderRequestFlowPreferenceReturn => {
  const { data, isFetching } = useQuery({
    ...userPreferenceQueryConfig.getOrderRequestFlow(userId),
  })

  return {
    preferredOrderRequestFlow: data,
    isFetching,
  }
}
